import { useEffect } from "react";
import { useIntl } from "react-intl";
import { Control } from "react-hook-form";

import { UseFormSetDefault } from "@/hooks/useSetDefault";

import { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";
import { TalentDetails } from "@aglocal/schema/Interview";

export interface LocationCommentsFieldProps {
  details: Readonly<TalentDetails> | undefined;
  control: Control<PostMeetingFormWithSummary>;
  setDefault: UseFormSetDefault<PostMeetingFormWithSummary>;
}

export default function LocationCommentsField({
  details,
  control,
  setDefault,
}: LocationCommentsFieldProps) {
  const { $t } = useIntl();
  const defaultValue = details?.locationComments ?? "";

  useEffect(() => {
    setDefault("locationComments", defaultValue);
  }, [defaultValue, setDefault]);

  return (
    <TextField
      name="locationComments"
      label={$t(FIELD_LABELS.locationComments)}
      control={control}
    />
  );
}
